import { whatIfOrDefaultSelector, whatIfInnerSelector } from '../../../WhatIfsSelector';

export const NO_MORTGAGE_VALUE = null;

export const mortgageTypeOptions = (state, props) => {
  const whatIf = whatIfOrDefaultSelector(state, props);
  const whatIfOptions = whatIf.Options || {};
  if (!whatIfOptions.MortgageTypeOptions) {
    return [];
  }

  return [
    {
      value: NO_MORTGAGE_VALUE,
      label: 'No Mortgage',
    },
    ...whatIfOptions.MortgageTypeOptions,
  ];
};

export const mortgageSelected = (state, props) => (
  whatIfInnerSelector(state, props).MortgageType
);
